<ng-select #emaAccountSelect
           bindLabel="name"
           [items]="(emaAccounts$ | async) ?? []"
           [typeahead]="emaAccountsSearchInput$"
           [minTermLength]="minSearchTermLength"
           [loading]="emaAccountsLoading"
           [clearable]="true"
           [virtualScroll]="false"
           [ngStyle]="{'width': '100%'}"
           [readonly]="readOnly"
           [disabled]="!selectedOrganization"
           [(ngModel)]="selectedEmaAccount"
           (change)="onEmaAccountChange($event)"
           (search)="onSearchTermChange($event)"
           (clear)="resetCurrentSearch()"
           (open)="onDropdownOpen()"
           (close)="onDropdownClose()"
           class="default-style custom-dropdown magnifier mb-2"
           data-identifier="users-site-select">
    <ng-template ng-header-tmp>
        <div class="row">
            <div class="col-3">
                <div><strong>Name</strong></div>
            </div>
            <div class="col-3">
                <div><strong>Username</strong></div>
            </div>
            <div class="col-3">
                <div><strong>Email</strong></div>
            </div>
            <div class="col-3">
                <div><strong>Role</strong>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div class="row">
            <div class="col-3">
                <div *ngIf="(item | lastAndFirstName | orDash | truncate) as truncatedName">
                    <span *ngIf="!truncatedName.isTruncated" class="fw-normal">{{ truncatedName.text }}</span>
                    <lib-tooltip *ngIf="truncatedName.isTruncated" [tooltipText]="item | lastAndFirstName">
                        <span class="fw-normal">{{ truncatedName.text }}</span>
                    </lib-tooltip>
                </div>
            </div>
            <div class="col-3">
                <div *ngIf="(item.username | orDash | truncate:25) as truncatedUsername">
                    <span *ngIf="!truncatedUsername.isTruncated" class="fw-normal">{{ truncatedUsername.text }}</span>
                    <lib-tooltip *ngIf="truncatedUsername.isTruncated" [tooltipText]="item.username">
                        <span class="fw-normal">{{ truncatedUsername.text }}</span>
                    </lib-tooltip>
                </div>
            </div>
            <div class="col-3">
                <div *ngIf="(item.email | orDash | truncate:25) as truncatedEmail">
                    <span *ngIf="!truncatedEmail.isTruncated" class="fw-normal">{{ truncatedEmail.text }}</span>
                    <lib-tooltip *ngIf="truncatedEmail.isTruncated" [tooltipText]="item.email">
                        <span class="fw-normal">{{ truncatedEmail.text }}</span>
                    </lib-tooltip>
                </div>
            </div>
            <div class="col-3">
                <div *ngIf="(item.role | orDash | truncate:25) as truncatedRole">
                    <span *ngIf="!truncatedRole.isTruncated" class="fw-normal">{{ truncatedRole.text }}</span>
                    <lib-tooltip *ngIf="truncatedRole.isTruncated" [tooltipText]="item.role">
                        <span class="fw-normal">{{ truncatedRole.text }}</span>
                    </lib-tooltip>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template ng-footer-tmp *ngIf="morePages">
        <p class="placeholder-color">There are more results based on your search. Type more characters to refine
            search.</p>
    </ng-template>
    <ng-template ng-footer-tmp *ngIf="noRecordsFound">
        <p class="placeholder-color">No records found</p>
    </ng-template>
</ng-select>


